import { Component, ViewEncapsulation, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: 'loader.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [FontAwesomeModule]
})
export class LoaderComponent {
  protected readonly loader = inject(LoaderService);
  readonly faSpinner = faSpinner;
}
